import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService, manageFilters } from '@app/services';
import { IActiveFilter } from '@app/models';

class LicenseAllocationService {
    getTenantLicense(): AxiosPromise {
        return apiService.get('/api/directory/Organizations/TenantLicense').catch((error: AxiosResponse) => Promise.reject(error));
    }

    getOrgLicenses(orderBy: string, asc: string, top: number, skip: number, count: boolean, filters?: IActiveFilter[]): AxiosPromise {
        return apiService
            .get('/api/directory/Organizations/OrgLicensesForTenant', {
                params: {
                    $orderBy: orderBy + ' ' + asc,
                    $top: top,
                    $count: count,
                    $skip: skip,
                    $filter: manageFilters(filters)
                }
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    assignSeatsFeaturesToOrg(jsonObject: any, handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl: string = '/api/directory/Organizations/AssignSeatsFeaturesToOrg';

        return apiService.post(apiUrl, jsonObject, { onError: handleError, onSuccess: handleSuccess }).catch();
    }

    getOrgLicense(orgId: string, handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl: string = `/api/directory/Organizations(${orgId})/GetOrgLicense`;

        return apiService.get(apiUrl, { onError: handleError, onSuccess: handleSuccess }).catch();
    }
}

export const licenseAllocationService = new LicenseAllocationService();
